import { BaseFieldModel, IBaseFieldModel } from '../base/blueprint-field-base.model';

export interface IFieldTextModel extends IBaseFieldModel {
  isRequired: boolean;
  isReadOnly: boolean;
  isMasked: boolean;
  maxLength: number;
  value: string;
}

export class FieldTextModel extends BaseFieldModel implements IFieldTextModel {
  constructor(
    public isRequired: boolean,
    public isReadOnly: boolean,
    public isMasked: boolean,
    public maxLength: number,
    public value: string,
  ) {
    super(isRequired, isReadOnly);
  }
}
